import React from 'react';
import UnderConstruction from '../../../../components/UnderConstruction';
import SharedHeader from '../../../../components/SharedHeader';
import DashboardFooter from '../../../../components/DashboardFooter';
import './special_subscription.css';

// # Special Subscription component (currently under construction)
const SpecialSubscription = () => {
  return (
    <div className="spec_sub_container">
      <SharedHeader title="Special Subscription" />
      
      <div className="spec_sub_content">
        <UnderConstruction pageName="Special Subscription" />
      </div>
      
      <DashboardFooter />
    </div>
  );
};

export default SpecialSubscription; 